<template>
    <footer>
        <hr>
        <div class="container">
            <p>MEANager <span class="version">v1.0.0 - ae25f5b31960ccd6e83dcbba96959f000f23c0cc</span> | Felix Moche</p>
            <div id="locale-wrap" class="btn-group mb-3">
                <b-button :class="{ active: this.locale === 'de' }" size="sm" variant="primary"
                          @click="changeLanguage('de')">
                    {{ 'BUTTON_TEXT_DE' | translate }}
                </b-button>
                <b-button :class="{ active: this.locale === 'en' }" size="sm" variant="success"
                          @click="changeLanguage('en')">
                    {{ 'BUTTON_TEXT_EN' | translate }}
                </b-button>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name:    'pageFooter',
    data() {
        return {
            locale: this.$i18n.locale()
        };
    },
    methods: {
        changeLanguage(locale) {
            if (this.$i18n.localeExists(locale)) {
                this.locale = locale;
                this.$i18n.set(this.locale);
                this.$store.commit('SET_LANGUAGE', { language: locale });
            }
        }
    }
};
</script>

<style>
footer p {
    font-size: .9em;
}

.version {
    word-break: break-all;
}
</style>
